import { requests } from "../../utils/helpers/api.services";
import { CATEGORY_URL } from "../../utils/helpers/api.routes";


export const CategoryServicee = {
    getAllCategories: (filterParams?: any) => requests.get(`${CATEGORY_URL}`, filterParams),
}